<template>
  <v-menu
    v-model="accountMenu"
    :close-on-content-click="false"
    :nudge-width="100"
    offset-y
    content-class="elevation-1"
  >
    <template v-slot:activator="{ on }">
      <div class="ma-2 p-accountIcon" v-on="on">
        <Avatar v-if="currentUser.avatar && currentUser.avatar.url != null" :src="currentUser.avatar.url" />
        <NoAvatar v-else />
      </div>
    </template>

    <v-card>
      <v-list dense>
        <v-list-item>
          <v-list-item-avatar
            v-if="currentUser.avatar && currentUser.avatar.url != null"
          >
            <img class="p-accountIcon__img" :src="currentUser.avatar.url" />
          </v-list-item-avatar>
          <v-list-item-avatar v-else>
            <v-icon class="p-accountIcon__img" color="grey">
              mdi-account
            </v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ currentUser.name }} </v-list-item-title>
            <v-list-item-subtitle>
              {{ currentUser.title }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-list dense>
        <slot />
      </v-list>
      <v-card-actions>
        <LogoutBtn />
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import LogoutBtn from '@/components/commons/LogoutBtn'
import { mapState } from 'vuex'
import Avatar from '../../../components/shared/Avatar'
import NoAvatar from '../../../components/shared/NoAvatar'
import ProfileListItem from '../../../components/uiParts/ListItems/Profile'
import PasswordListItem from '../../../components/uiParts/ListItems/Password'

export default {
  components: {
    PasswordListItem,
    ProfileListItem,
    NoAvatar,
    Avatar,
    LogoutBtn
  },
  data: () => ({
    accountMenu: false
  }),
  computed: {
    ...mapState({
      currentUser: (state) => state.UserStore.currentUser
    })
  }
}
</script>

<style scoped lang="sass">
.p-accountIcon
  vertical-align: middle
  &__img
    display: block
    border: 2px solid #D3D3D3
    border-radius: 50%
    height: 40px
    width: 40px
    &:hover
      cursor: pointer
.accountMenu
  z-index: 999
</style>
